import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmployeePayrollService } from 'app/core/services/employee-payroll.service';
import { RefreshScalelineService } from 'app/core/services/refresh-scaleline/refresh-scaleline.service';
import { SalaryScaleService } from 'app/core/services/salary-scale.service';

@Component({
  selector: 'dialog-delete-payrollline',
  templateUrl: './dialog-delete-payrollline.component.html',
  styleUrls: ['./dialog-delete-payrollline.component.scss']
})
export class DialogDeletePayrolllineComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeletePayrolllineComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private employeePayrollService: EmployeePayrollService, private refrehScaleLineService: RefreshScalelineService) { }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteSelectedElement() {
    this.isLoading = true;
    this.employeePayrollService.deletePayrollLine(this.data.selectedIds).subscribe({
      next: (res) => {
        this.refrehScaleLineService.emitRefresh(this.data.selectedIds);
        Promise.resolve().then(() => {
          this.isLoading = false;
          this.dialogRef.close();
        });
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting element:', err);
        alert('Failed to delete selected element.');
      },
    });
  }

}
